// @flow
import omit from 'lodash/omit';
import type { TrpcFile } from 'digicel-kaizen-library';

export const contractsSelector = (state: any) => {
  const contracts = state.legalDocuments.contracts;

  if (!contracts) {
    return null;
  }

  return omit(contracts, 'null');
};

export const contractsBySubscriptionProductSerialNumberSelector = (state: any, serialNumber: string): TrpcFile[] => {
  const contracts = contractsSelector(state);

  if (contracts != null) {
    return contracts[serialNumber];
  }

  return [];
};
